import React, { FC, useState } from 'react';
import { FieldLabel } from '../../../../../common';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
// import { FIELD_FEEDBACK_TYPES, FieldFeedback } from '../../../../../common/FieldFeedback';
import FIOApiService from '../services/FIOApiService';
import { IDadataFIO, IFIOInfo } from '../fio-interfaces';
import { useField } from 'formik';

interface IDadataFieldProps {
  name: string;
  handleChosenPerson: (ev: IFIOInfo) => void;
}

export const DadataField: FC<IDadataFieldProps> = ({ name, handleChosenPerson }) => {
  const dadataApiClient = new FIOApiService();
  const [options, setOptions] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [{ value }] = useField(name);

  const loadPeopleList = (fioSearchString: string): void => {
    setIsLoading(true);

    dadataApiClient
      .getPeopleList(fioSearchString)
      .then((people: string[]) => setOptions(people))
      .finally(() => setIsLoading(false));
  };

  const onSelected = ([FIO]: string[]): void => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    dadataApiClient.getSingleFIO(FIO).then(
      (singleFIO: IDadataFIO) =>
        singleFIO &&
        handleChosenPerson({
          firstName: singleFIO.data.name,
          middleName: singleFIO.data.patronymic,
          lastName: singleFIO.data.surname,
          dadataFio: { data: singleFIO.data, unrestrictedValue: singleFIO.unrestricted_value, value: singleFIO.value },
        }),
    );
  };

  return (
    <div className="form-group">
      <FieldLabel label="Поиск по фамилии, имени, отчеству" />
      <AsyncTypeahead
        placeholder="ФИО не указано"
        id={`${name}-fio-field`}
        options={options}
        useCache={false}
        filterBy={(option) => !!option}
        isLoading={isLoading}
        onSearch={loadPeopleList}
        onChange={onSelected}
        clearButton
        delay={300}
        defaultSelected={[`${value.lastName || ''} ${value.firstName || ''} ${value.middleName || ''}`]}
        promptText="Введите текст, чтобы начать поиск..."
        searchText="Осуществляется поиск..."
      />
      <div className="mt-1">
        {/* <FieldFeedback type={addressFeedback?.type as FIELD_FEEDBACK_TYPES} text={addressFeedback?.text} />*/}
      </div>
    </div>
  );
};
